import { z } from "zod";

import { WidgetDecimals } from "../../components/widget-form/decimals/form-state";

export const dashboardWidgetFormatDecimalPlacesSchema = z
	.union([
		z
			.string()
			.trim()
			.pipe(z.literal(""))
			.transform(() => undefined),
		z.coerce.number().min(WidgetDecimals.min).max(WidgetDecimals.max),
	])
	.optional();

export const dashboardWidgetFormatSchema = z.object({
	unit: z.string().trim().optional().catch(undefined),
	decimalPlaces: dashboardWidgetFormatDecimalPlacesSchema,
});

export type DashboardWidgetFormat = z.infer<typeof dashboardWidgetFormatSchema>;

export type DashboardWidgetFormatDecimalPlaces = z.infer<typeof dashboardWidgetFormatDecimalPlacesSchema>;
